import { put, call } from 'redux-saga/effects';
import { isArray } from 'lodash';

import { actions as LoadingActions } from '../LoadingScreen';
import logging from './logging';

export function withLoadingIndicators(generatorFunction) {
  return function* loadingIndicators(...args) {
    try {
      yield put(LoadingActions.startLoading());
      yield* generatorFunction(...args);
    } catch (error) {
      logging.error(error);
    } finally {
      yield put(LoadingActions.finishLoading());
    }
  };
}

export function* callPut(...args) {
  const puttables = yield call(...args);
  if (!puttables) {
    return;
  }

  if (isArray(puttables)) {
    yield* (puttables.map(puttable => put(puttable)));
  } else {
    yield put(puttables);
  }
}
